import drawingLayerTypes from 'helpers/enums/drawingLayerTypes'
import {buildColor} from 'components/drawit/helpers/colorsToPick'

const supportedTypes = [drawingLayerTypes.PENCIL, drawingLayerTypes.MARKER, drawingLayerTypes.ERASE]

function getList(actions) {
	return actions.filter(action => supportedTypes.includes(action.type))
}

const delay = () => new Promise(resolve => {
	setTimeout(resolve, 1)
})

async function drawTracesBatch(drawing, canvasContext) {
	const {color, width, compositeOperation, init_pos, opacity, traces, type} = drawing
	canvasContext.strokeStyle = buildColor(color, opacity)
	canvasContext.lineWidth = width
	canvasContext.globalCompositeOperation = compositeOperation
	let previousX = init_pos[0]
	let previousY = init_pos[1]
	canvasContext.beginPath()
	let traceIndex = 0
	const maxTraceBatch = 100
	while (traceIndex < traces.length) {
		if (type !== drawingLayerTypes.MARKER) {
			canvasContext.beginPath()
		}
		const trace = traces[traceIndex]
		const traceWidth = trace[2] ? trace[2] : width
		canvasContext.lineWidth = traceWidth
		canvasContext.moveTo(previousX, previousY)
		canvasContext.lineTo(trace[0], trace[1])
		if (traceIndex % maxTraceBatch === 0) {
			await delay()
		}
		if (type !== drawingLayerTypes.MARKER) {
			canvasContext.stroke()
		}
		previousX = trace[0]
		previousY = trace[1]
		traceIndex += 1
	}
	if (!traces.length) {
		canvasContext.rect(init_pos[0], init_pos[1], 1, 1)
		canvasContext.stroke()
	} else if (type === drawingLayerTypes.MARKER) {
		canvasContext.stroke()
	}
}

async function drawTraces(list, width, height) {
	const canvas = document.createElement('canvas')
	canvas.width = width
	canvas.height = height
	const canvasContext = canvas.getContext('2d')
	canvasContext.lineCap = 'round'
	canvasContext.lineJoin = 'round'
	canvasContext.miterLimit = 0
	let drawingIndex = 0
	while (drawingIndex < list.length) {
		await drawTracesBatch(list[drawingIndex], canvasContext)
		await delay()
		drawingIndex += 1
	}
	return canvas
}


async function saveTraces(actions, width, height) {
	const list = await getList(actions)
	const canvas = await drawTraces(list, width, height)
	return canvas
}

export default saveTraces
